import React from 'react'
import navHeader from './navbar.module.css'

const Navbar = props => {
  const path = props.pathname.split('/')[1]
  const langPath = path == 'en-CA' ? true : path == 'board' ? true : false

  const container = {
    display: 'flex',
  }
  const TopLevelMenu = {
    paddingLeft: '5px',
    color: '#d22528',
  }
  const TopLevelMenuLH = {
    paddingLeft: '5px',
    color: '#d22528',
    lineHeight: '1.5',
  }
  const SubMenuIndent = {
    paddingLeft: '20px',
    fontSize: '16px',
  }

  const SubMenuIndentLH = {
    paddingLeft: '20px',
    fontSize: '16px',
    lineHeight: '1.5',
  }

  return (
    <div style={container}>
      <div className={navHeader.MenuContainer}>
        <div>
          {langPath ? (
            <div style={{ zIndex: '0' }}>
              <a href="/en-CA" title="CREA Logo" alt="CREA Logo">
                <div className="CREA_Dark_Logo" />
                <div className="CREA_Light_Logo" />
              </a>
            </div>
          ) : (
            <div>
              <a href="/fr-CA" title="ACI Logo" alt="ACI Logo">
                <div className="CREA_Dark_Logo_FR" />
                <div className="CREA_Light_Logo_FR" />
              </a>
            </div>
          )}
        </div>
        <div className={navHeader.Menu}>
          {langPath ? (
            <ul id="Dark_Header_style">
              <li>
                <a href="#">
                  <span>Who We Are</span>
                </a>
                <ul className={navHeader.subMenu}>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/mission/"
                      style={TopLevelMenu}
                    >
                      Our Mission
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/mission/values-strategic-overview/"
                      style={SubMenuIndent}
                    >
                      Our Values & Strategic Overview
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/mission/deia-commitments/"
                      style={SubMenuIndent}
                    >
                      Our DEIA Commitments
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/realtor-association-community/"
                      style={TopLevelMenu}
                    >
                      REALTOR® Association Community
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/leadership/"
                      style={TopLevelMenu}
                    >
                      Our Leadership
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/leadership/volunteer-committees/"
                      style={SubMenuIndent}
                    >
                      Our Volunteer Committees
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/the-realtor-difference/"
                      style={TopLevelMenu}
                    >
                      The REALTOR® Difference
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/the-realtor-difference/become-a-realtor/"
                      style={SubMenuIndent}
                    >
                      Become a REALTOR®
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/the-realtor-difference/new-realtors/"
                      style={SubMenuIndent}
                    >
                      New REALTORS®
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/who-we-are/the-realtor-difference/brokers/"
                      style={SubMenuIndent}
                    >
                      Brokers
                    </a>
                  </li>
                </ul>
              </li>{' '}
              <li>
                <a href="#">
                  <span>Advocacy</span>
                </a>
                <ul className={navHeader.subMenu}>
                  <li>
                    <a
                      href="https://www.crea.ca/advocacy/political-advocacy/"
                      style={TopLevelMenu}
                    >
                      Political Advocacy
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/advocacy/political-advocacy/pac-days/"
                      style={SubMenuIndent}
                    >
                      PAC Days
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/advocacy/political-advocacy/past-successes/"
                      style={SubMenuIndent}
                    >
                      Past Successes
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/advocacy/realtor-recommendations/"
                      style={TopLevelMenu}
                    >
                      REALTOR® Reccomendations
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/advocacy/realtor-recommendations/protecting-homeownership/"
                      style={SubMenuIndent}
                    >
                      Protecting Homeownership
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/advocacy/realtor-recommendations/protecting-homeownership/homeownership-dividend-for-canadians/"
                      style={SubMenuIndent}
                    >
                      The Homeownership Dividend for Canadians
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#">
                  <span>REALTOR® & Consumer Tech</span>
                </a>
                <ul className={navHeader.subMenu}>
                  <li>
                    <a
                      href="https://www.crea.ca/technology/realtor-ca-for-canadians/"
                      style={TopLevelMenu}
                    >
                      REALTOR.ca for Canadians
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/technology/realtor-ca-for-canadians/"
                      style={TopLevelMenu}
                    >
                      REALTOR.ca for REALTORS®
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/technology/realtor-ca-for-realtors/realtor-ca-tools/"
                      style={SubMenuIndent}
                    >
                      REALTOR.ca Tools
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/technology/realtor-ca-for-realtors/realtor-ca-tools/realtor-ca-ddf/"
                      style={SubMenuIndent}
                    >
                      REALTOR.ca DDF®
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/technology/realtor-ca-for-realtors/realtor-ca-tools/listing-stats-app/"
                      style={SubMenuIndent}
                    >
                      Listing Stats App
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/technology/crea-webforms/"
                      style={TopLevelMenu}
                    >
                      CREA WEBForms®
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#">
                  <span>Standards & Programs</span>
                </a>
                <ul className={navHeader.subMenu}>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/reputation/"
                      style={TopLevelMenu}
                    >
                      Reputation
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/reputation/national-ad-campaign/"
                      style={SubMenuIndent}
                    >
                      National Ad Campaign
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/reputation/learning-development/"
                      style={SubMenuIndent}
                    >
                      Learning & Development
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/realtor-code/"
                      style={TopLevelMenu}
                    >
                      REALTOR® Code
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/reputation/learning-development/"
                      style={TopLevelMenu}
                    >
                      Trademark Protection & Competition
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/trademark-protection-competition/pledge-of-competition/"
                      style={SubMenuIndent}
                    >
                      Pledge of Completion
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/programs/"
                      style={TopLevelMenu}
                    >
                      Our Programs
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/programs/realtors-care/"
                      style={SubMenuIndent}
                    >
                      REALTORS Care®
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/programs/crea-global/"
                      style={SubMenuIndent}
                    >
                      CREA Global
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/standards-programs/programs/young-professionals-network/"
                      style={SubMenuIndent}
                    >
                      YPN Connection
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#">
                  <span>Housing Market Analysis</span>
                </a>
                <ul className={navHeader.subMenu}>
                  <li>
                    <a
                      href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/"
                      style={TopLevelMenu}
                    >
                      Canadian Housing Market Stats
                    </a>
                  </li>
                  <li>
                    <a href="/" style={SubMenuIndent}>
                      Monthly Stats Report
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/quarterly-forecasts/"
                      style={SubMenuIndent}
                    >
                      Quarterly Forecasts
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/national-price-map/"
                      style={SubMenuIndent}
                    >
                      National Price Map
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/housing-market-stats/mls-home-price-index/"
                      style={TopLevelMenu}
                    >
                      MLS® Home Price Index (HPI)
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/housing-market-stats/mls-home-price-index/about-hpi/"
                      style={SubMenuIndent}
                    >
                      About MLS® HPI
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/housing-market-stats/mls-home-price-index/getting-started/"
                      style={SubMenuIndent}
                    >
                      How Does the MLS® HPI Help Me?
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/housing-market-stats/mls-home-price-index/hpi-tool/"
                      style={SubMenuIndent}
                    >
                      Try the MLS® HPI Tool
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/housing-market-stats/mls-home-price-index/resources/"
                      style={SubMenuIndent}
                    >
                      Reference Materials
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#">
                  <span>Media Hub</span>
                </a>
                <ul className={navHeader.subMenu}>
                  <li>
                    <a
                      href="https://www.crea.ca/media-hub/news/"
                      style={TopLevelMenu}
                    >
                      News Releases & Statements
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/media-hub/events-sponsorships/"
                      style={TopLevelMenu}
                    >
                      Events & Sponsorships
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/media-hub/annual-reports/"
                      style={TopLevelMenu}
                    >
                      Annual Reports
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/media-hub/newsletters/"
                      style={TopLevelMenu}
                    >
                      Newsletters
                    </a>
                  </li>
                  <li>
                    <a href="http://news2me.crea.ca/" style={SubMenuIndent}>
                      News2Me For REALTORS®
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.realtor.ca/my-account#section=Communications"
                      style={SubMenuIndent}
                    >
                      REALTOR.ca Newsletters For Canadians
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/media-hub/blogs/"
                      style={TopLevelMenu}
                    >
                      Blogs
                    </a>
                  </li>
                  <li>
                    <a href="https://www.creacafe.ca/" style={SubMenuIndent}>
                      CREA Café Blog for REALTORS®
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.realtorscare.ca/"
                      style={SubMenuIndent}
                    >
                      REALTORS Care® Stories
                    </a>
                  </li>
                  <li>
                    <a href="https://www.realtor.ca/blog" style={SubMenuIndent}>
                      REALTOR.ca Living Blog for Canadians
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/media-hub/real-time-podcast/"
                      style={TopLevelMenu}
                    >
                      REAL TIME Podcast
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/media-hub/publications/"
                      style={TopLevelMenu}
                    >
                      CREA Publications
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.crea.ca/media-hub/covid-19/"
                      style={TopLevelMenu}
                    >
                      COVID-19 Ressources
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          ) : (
            <div className={navHeader.MenuFR}>
              <ul id="Dark_Header_style">
                <li>
                  <a href="#">
                    <span>À propos de nous</span>
                  </a>
                  <ul className={navHeader.subMenu}>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/a-propos/notre-mission/"
                        style={TopLevelMenu}
                      >
                        Notre mission
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/a-propos/notre-mission/apercu-strategique-de-laci/"
                        style={SubMenuIndent}
                      >
                        Nos valeurs et notre aperçu stratégique{' '}
                      </a>
                    </li>
                    <li style={SubMenuIndentLH}>
                      <a href="https://www.crea.ca/fr/a-propos/notre-mission/nos-valeurs-et-nos-engagements-en-matiere-de-deia/">
                        Nos engagements en matière de diversité, d’équité,
                        d’inclusion et d’antiracisme (DEIA)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/a-propos/communaute-des-associations-immobilieres/"
                        style={TopLevelMenu}
                      >
                        Communauté des associations immobilières
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/a-propos/membres-de-la-direction/"
                        style={TopLevelMenu}
                      >
                        Membres de la direction
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/a-propos/membres-de-la-direction/comites-de-benevoles/"
                        style={SubMenuIndent}
                      >
                        Comités de bénévoles
                      </a>
                    </li>
                    <li style={TopLevelMenuLH}>
                      <a
                        href="https://www.crea.ca/fr/a-propos/le-membre-de-laci-plus-quun-courtier-ou-agent-immobilier/"
                        style={{ color: '#d22528' }}
                      >
                        Le membre de l’ACI, plus qu’un courtier ou agent
                        immobilier
                      </a>
                    </li>
                    <li style={SubMenuIndentLH}>
                      <a href="https://www.crea.ca/fr/a-propos/le-membre-de-laci-plus-quun-courtier-ou-agent-immobilier/devenir-courtier-ou-agent-immobilier-detenteur-du-titre-realtorr/">
                        Devenir courtier ou agent immobilier, détenteur du titre
                        REALTOR®
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/a-propos/le-membre-de-laci-plus-quun-courtier-ou-agent-immobilier/nouveaux-courtiers-et-agents-membres/"
                        style={SubMenuIndent}
                      >
                        Nouveaux courtiers et agents membres
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/a-propos/le-membre-de-laci-plus-quun-courtier-ou-agent-immobilier/brokers/"
                        style={SubMenuIndent}
                      >
                        Brokers
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#">
                    <span>Défense des intérêts</span>
                  </a>
                  <ul className={navHeader.subMenu}>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/defense-des-interets/defense-des-interets-politiques/"
                        style={TopLevelMenu}
                      >
                        Défense des intérêts politiques
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/defense-des-interets/defense-des-interets-politiques/les-journees-du-cap/"
                        style={SubMenuIndent}
                      >
                        Les Journées du CAP
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/defense-des-interets/defense-des-interets-politiques/nos-reussites/"
                        style={SubMenuIndent}
                      >
                        Nos réussites
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/defense-des-interets/recommandations-des-membres-de-laci/"
                        style={TopLevelMenu}
                      >
                        Recommandations des membres de l’ACI
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/defense-des-interets/recommandations-des-membres-de-laci/protection-de-laccession-a-la-propriete/"
                        style={SubMenuIndent}
                      >
                        Protection de l’accession à la propriété
                      </a>
                    </li>
                    <li style={SubMenuIndentLH}>
                      <a href="https://www.crea.ca/fr/defense-des-interets/recommandations-des-membres-de-laci/protection-de-laccession-a-la-propriete/le-dividende-de-la-propriete-pour-les-canadiens/">
                        Le dividende de la propriété pour les Canadiens
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <li style={{ width: '150px', lineHeight: '22px' }}>
                    {' '}
                    <a href="#">
                      <span>
                        Technologie pour nos membres et les consommateurs
                      </span>
                    </a>
                  </li>

                  <ul className={navHeader.subMenu}>
                    <li style={TopLevelMenuLH}>
                      <a
                        href="https://www.crea.ca/fr/technologie/realtor-ca-au-service-de-la-population-canadienne/"
                        style={{ color: '#d22528' }}
                      >
                        REALTOR.ca : au service de la population canadienne
                      </a>
                    </li>
                    <li style={TopLevelMenuLH}>
                      <a
                        href="https://www.crea.ca/fr/technologie/realtor-ca-au-service-des-courtiers-et-agents-immobiliers/"
                        style={{ color: '#d22528' }}
                      >
                        REALTOR.ca : au service des courtiers et agents
                        immobiliers
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/technologie/realtor-ca-au-service-des-courtiers-et-agents-immobiliers/outils-realtor-ca/"
                        style={SubMenuIndent}
                      >
                        Outils REALTOR.ca
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/technologie/realtor-ca-au-service-des-courtiers-et-agents-immobiliers/outils-realtor-ca/le-sdd-de-realtor-ca/"
                        style={SubMenuIndent}
                      >
                        Le SDD<sup>MC</sup> de REALTOR.ca
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/technologie/realtor-ca-au-service-des-courtiers-et-agents-immobiliers/outils-realtor-ca/lapplication-realtor-ca-mes-stats/"
                        style={SubMenuIndent}
                      >
                        L’application REALTOR.ca – Mes stats
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/technologie/webforms-aci/"
                        style={TopLevelMenu}
                      >
                        WEBForms® – ACI
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#">
                    <span>Normes et programmes</span>
                  </a>
                  <ul className={navHeader.subMenu}>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/reputation/"
                        style={TopLevelMenu}
                      >
                        Réputation
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/reputation/campagne-publicitaire-nationale/"
                        style={SubMenuIndent}
                      >
                        Campagne publicitaire nationale
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/reputation/apprentissage-et-perfectionnement/"
                        style={SubMenuIndent}
                      >
                        Apprentissage et perfectionnement
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/code-de-conduite-des-membres-de-laci/"
                        style={TopLevelMenu}
                      >
                        Code de conduite des membres de l’ACI
                      </a>
                    </li>
                    <li style={TopLevelMenuLH}>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/protection-des-marques-de-commerce-et-concurrence/"
                        style={{ color: '#d22528' }}
                      >
                        Protection des marques de commerce et concurrence
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/protection-des-marques-de-commerce-et-concurrence/engagement-en-matiere-de-concurrence/"
                        style={SubMenuIndent}
                      >
                        Engagement en matière de concurrence
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/programmes/"
                        style={TopLevelMenu}
                      >
                        Programmes
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/programmes/realtors-care/"
                        style={SubMenuIndent}
                      >
                        REALTOR Care®
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/programmes/aci-international/"
                        style={SubMenuIndent}
                      >
                        ACI – International
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/normes-programmes/programmes/connexion-rjp/"
                        style={SubMenuIndent}
                      >
                        Connexion RJP
                      </a>
                    </li>
                  </ul>
                </li>
                <li style={{ width: '100px', lineHeight: '22px' }}>
                  {' '}
                  <a href="#">
                    <span>Analyses du marché de l’habitation</span>
                  </a>
                  <ul className={navHeader.subMenu}>
                    <li style={TopLevelMenuLH}>
                      <a
                        href="https://www.crea.ca/fr/analyses-du-marche-de-lhabitation/statistiques-sur-le-marche-de-lhabitation-canadien/"
                        style={{ color: '#d22528' }}
                      >
                        Statistiques sur le marché de l’habitation canadien
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://stats.crea.ca/fr-CA/"
                        style={SubMenuIndent}
                      >
                        Rapport statistique mensuel
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/analyses-du-marche-de-lhabitation/statistiques-sur-le-marche-de-lhabitation-canadien/previsions-trimestrielles/"
                        style={SubMenuIndent}
                      >
                        Prévisions trimestrielles
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/analyses-du-marche-de-lhabitation/statistiques-sur-le-marche-de-lhabitation-canadien/carte-du-prix-national/"
                        style={SubMenuIndent}
                      >
                        Carte du prix national
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/analyses-du-marche-de-lhabitation/indice-des-prix-des-proprietes-mls-ipp-mls/"
                        style={TopLevelMenu}
                      >
                        Indice des prix des propriétés MLS® (IPP MLS®)
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/analyses-du-marche-de-lhabitation/indice-des-prix-des-proprietes-mls-ipp-mls/a-propos-ipp/"
                        style={SubMenuIndent}
                      >
                        À propos de l’IPP MLS®
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/analyses-du-marche-de-lhabitation/indice-des-prix-des-proprietes-mls-ipp-mls/quels-avantages-me-procure-lipp-mls/"
                        style={SubMenuIndent}
                      >
                        Quels avantages me procure l’IPP MLS®?
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/analyses-du-marche-de-lhabitation/indice-des-prix-des-proprietes-mls-ipp-mls/essayez-loutil-ipp-mls/"
                        style={SubMenuIndent}
                      >
                        Essayez l’outil IPP MLS®
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/analyses-du-marche-de-lhabitation/indice-des-prix-des-proprietes-mls-ipp-mls/documentation/"
                        style={SubMenuIndent}
                      >
                        Documentation
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#">
                    <span>Centre des médias</span>
                  </a>
                  <ul className={navHeader.subMenu}>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/centre-des-medias/communiques/"
                        style={TopLevelMenu}
                      >
                        Communiqués et déclarations
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/centre-des-medias/evenements-et-commandites-de-laci/"
                        style={TopLevelMenu}
                      >
                        Événements et commandites de l’ACI
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/centre-des-medias/rapports-annuel/"
                        style={TopLevelMenu}
                      >
                        Rapports annuels
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/centre-des-medias/infolettres/"
                        style={TopLevelMenu}
                      >
                        Infolettres
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://news2me.crea.ca/fr/"
                        style={SubMenuIndent}
                      >
                        Quoi de 9? pour les membres
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.realtor.ca/my-account#section=Communications"
                        style={SubMenuIndent}
                      >
                        Infolettre REALTOR.ca pour les Canadiens
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/centre-des-medias/blogues/"
                        style={TopLevelMenu}
                      >
                        Blogues
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.creacafe.ca/fr/"
                        style={SubMenuIndent}
                      >
                        Café ACI pour les membres
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.realtorscare.ca/fr/"
                        style={SubMenuIndent}
                      >
                        Nos histoires REALTORS Care®
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.realtor.ca/blogue"
                        style={TopLevelMenu}
                      >
                        Salon de REALTOR.ca pour les Canadiens
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/centre-des-medias/balado-en-direct/"
                        style={TopLevelMenu}
                      >
                        Le balado EN DIRECT
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/centre-des-medias/publications/"
                        style={TopLevelMenu}
                      >
                        Publications
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.crea.ca/fr/centre-des-medias/covid-19/"
                        style={TopLevelMenu}
                      >
                        COVID-19
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Navbar
